import { render, staticRenderFns } from "./TableDisplayText.vue?vue&type=template&id=340d732e&"
import script from "./TableDisplayText.vue?vue&type=script&lang=ts&"
export * from "./TableDisplayText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports